import DownloadTicketButton from 'app/components/DownloadTicketButton/DownloadTicketButton';
import { Button } from 'app/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'app/components/ui/dropdown-menu';
import { Download, File, Image, WalletCards } from 'lucide-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadLinks } from '../RegistrationFormPage';

interface DownloadTicketsMenuProps {
  download: DownloadLinks;
}

const DownloadTicketsMenu: React.FC<DownloadTicketsMenuProps> = ({
  download,
}) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            setIsOpen(val => !val);
          }}
        >
          <Download size={20} />
          {t('orderConfirmationPage.ticketDownload')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="shadow-xl">
        <DropdownMenuItem>
          <DownloadTicketButton link={download.png}>
            <Image size={16} />
            {t('registrationFormsPage.image')}
          </DownloadTicketButton>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <DownloadTicketButton link={download.pdf}>
            <File size={16} />
            {t('registrationFormsPage.pdf')}
          </DownloadTicketButton>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default DownloadTicketsMenu;
